import withLazyLoading from '../../hoc/withLazyLoading';
import { createCrumbHandle, validatePermission } from '../../utilities/auth';

const DashboardPage = withLazyLoading(() => import('../../pages/dashboardPage'));
const DashboardConfig = withLazyLoading(() => import('../../pages/dashboardConfig'));
const PageConfig = withLazyLoading(() => import('../../pages/pageConfig'));
const PageConfigV2 = withLazyLoading(() => import('../../pages/pageConfigV2'));
const DashboardPageList = withLazyLoading(() => import('../../pages/DashboardPageList'));
const UnifiedDashboardPage2 = withLazyLoading(() => import('../../pages/UnifiedDashboardPage2'));
const UnifiedDashboardPageList = withLazyLoading(() => import('../../pages/UnifiedDashboardPageList'));
const UnifiedPageConfig = withLazyLoading(() => import('../../pages/UnifiedPageConfig'));
const DnDUnifiedPageConfig = withLazyLoading(() => import('../../pages/DnDUnifiedPageConfig'));
const AIAnalysisConfig = withLazyLoading(() => import('../../pages/AIAnalysisConfig'));

const dashboardRoutes = [
    {
        path: '/dashboardConfig/:plantId',
        element: <DashboardConfig />,
        loader: validatePermission('DashboardPage_Configuration_WE'),
        handle: createCrumbHandle('Dashboard Configuration')
    },
    // ---- Analytics Page ------
    {
        path: '/dashboardPage/:plantId',
        handle: createCrumbHandle('Dashboard'),
        children: [
            {
                index: true,
                element: <DashboardPage />,
            },
            {
                path: 'pageConfigv2/:plantId/:pageId',
                element: <PageConfigV2 />,
                handle: createCrumbHandle('Dashboard Configuration')
            },
            {
                path: 'DashboardPageList/:plantId',
                element: <DashboardPageList />,
                handle: createCrumbHandle('Dashboard Pages')
            }
        ]
    },
    // ------- Unified Dashboard -------
    {
        path: '/UnifiedDashboardPage/:pageId',
        handle: createCrumbHandle('Dashboard'),
        children: [
            {
                index: true,
                element: <UnifiedDashboardPage2 />,
                loader: validatePermission('UnifiedDashboardPage_View_R'),
            },
            {
                path: 'UnifiedDashboardPageList',
                element: <UnifiedDashboardPageList />,
                loader: validatePermission('UnifiedDashboardList_Manage_AE'),
                handle: createCrumbHandle('Dashboard Pages')
            },
            {
                path: 'UnifiedPageConfig/:pageId',
                element: <UnifiedPageConfig />,
                loader: validatePermission('UnifiedDashboardPage_Configuration_WE'),
                handle: createCrumbHandle('Dashboard Configuration')
            },
        ]
    },
    {
        // @has to remove it
        path: '/pageConfig/:plantId/:pageId',
        element: <PageConfig />,
        // loader:  validatePermission('Page_Config_A'),
        handle: createCrumbHandle('Dashboard Configuration')
    },
    {
        path: '/DnDUnifiedPageConfig/:pageId',
        element: <DnDUnifiedPageConfig />,
        loader: validatePermission('UnifiedDashboardPage_Configuration_WE'),
        handle: createCrumbHandle('Dashboard Configuration')
    },
    {
        path: '/AIAnalysisConfig',
        element: <AIAnalysisConfig />,
        handle: createCrumbHandle('AI Analysis Configuration')
    },
];

export default dashboardRoutes;
